import { useNavigation } from "@react-navigation/native";
import PageTitle from "../../components/PageTitle";
import ButtonChoose from "./components/ButtonChoose";
import { StyleSheet, View } from "react-native";
import { AuthContext } from "../../contexts/auth";
import { useContext } from "react";
import { GlobalContext } from "../../contexts/global";

export default function Home({ navigaton }) {
  const { roleUser } = useContext(AuthContext);
  const { setLoading, setShowAlert, showAlert } = useContext(GlobalContext);
  
  navigaton = useNavigation();
  return (
    <PageTitle title={"Início"}>
      <View style={styles.viewPrincipal}>
        <View style={styles.viewColumn}>
          <ButtonChoose
            title={"  Pedir Veículo  "}
            iconName={"car"}
            onPress={() => navigaton.navigate("OrderVehicle")}
          />
        </View>
        <View style={styles.viewColumn}>
          <ButtonChoose
            title={"Carimbo virtual"}
            iconName={"stamper"}
            onPress={() => {
              if (roleUser == "condominum" || roleUser == "admin") {
                navigaton.navigate("ScanQRCodeVirtualStamp");
              } else {
                setShowAlert({
                  type: "warning",
                  title: "Atenção",
                  message: "Você não tem permissão para acessar.",
                  show: true,
                  confirmText: "OK",
                  pressConfirm: () => {
                    setShowAlert({ ...showAlert, show: false });
                  },
                });
              }
            }}
          />
        </View>
      </View>
    </PageTitle>
  );
}

const styles = StyleSheet.create({
  viewPrincipal: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-start",
    flex: 1,
  },
  viewColumn: {
    alignItems: "center",
    marginHorizontal: 8,
  },
});
